import { Component, computed, input } from '@angular/core';
import { formatAddressState } from '../pace-spector.utils';
import { AddressState, TimesheetWorkEntryState } from '../../../state';

@Component({
    selector: 'pace-core-timesheet-entry-ngrx-spector',
    imports: [],
    templateUrl: './timesheet-entry-ngrx-spector.component.html',
    styleUrl: './timesheet-entry-ngrx-spector.component.css',
})
export class TimesheetEntryNgrxSpectorComponent {
    public entry = input.required<TimesheetWorkEntryState>();
    public addressesById = input.required<Map<string, AddressState>>();

    public formattedAddress = computed(() => {
        const address = this.entry().address;
        if (!address) {
            return 'undefined address';
        }
        const addressesById = this.addressesById();
        const addressState = addressesById?.get(address);
        return formatAddressState(addressState);
    });
}
